// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}

(function() {
  faq_taggol();  
  (document.querySelector("[data-header-tans]") || null) && document.body.classList.add("header-transparent");
})();


//faq section
const faq_main_wap = document.querySelector('[faq_main_wap]') || null;
if (faq_main_wap) {
  const faq_toggles = faq_main_wap.querySelectorAll('[data-act-title]') || null;
  const faq_content_wap = faq_main_wap.querySelector('[faq_content_wap]') || null;
  const faq_content_tabs = faq_content_wap.querySelectorAll('.tabs') || null;
  const faq_dropdown = faq_main_wap.querySelector('.faq-category-dropdown') || null;
  const faq_selected = faq_main_wap.querySelector('.faq-category-selected') || null;
  const mian_tag = document.querySelector('.faq-category')|| null;
  const content = document.querySelector("[js-acc-single-content]");
  
  if (faq_content_wap) {
    faq_toggles.forEach((faq) => {
      faq.addEventListener('click', (event) => {
        faq_content_tabs.forEach((tab) => {
          tab.classList.remove('active');
          tab.style.display = 'none';
        });

        faq_toggles.forEach((toggle) => {
          toggle.classList.remove('active-tab');
        });

        const targetSelector = event.currentTarget.getAttribute('data-act-title');
        const targetTab = faq_content_wap.querySelector(targetSelector);

        if (targetTab) {
          targetTab.classList.add('active');
          targetTab.style.display = 'block';
          
         
        }
        event.currentTarget.classList.add('active-tab');
        

        if (faq_dropdown && faq_selected) {
          faq_selected.textContent = event.currentTarget.textContent.trim();
          faq_dropdown.classList.remove('open'); // Adjust class based on your dropdown open state
          mian_tag.classList.remove('active');
          if(content){
            content.style.maxHeight = null;
          }
        }
      });
    });

    if (faq_dropdown) {
      faq_dropdown.addEventListener('click', () => {
        faq_dropdown.classList.toggle('open'); // Add/remove "open" class for the dropdown
      });
    }
  }
}
//faq section end


// --------- PDP Tab section
document.addEventListener('DOMContentLoaded', function () {
  const tabTitles = document.querySelectorAll('.tab-title');
  const tabContents = document.querySelectorAll('.product-tab-content');

  // ✅ Run only if tabs exist
  if (tabTitles.length === 0) return;

  tabTitles.forEach(title => {
    title.addEventListener('click', function () {
      const target = this.getAttribute('data-title');
    const removeclass = this.closest('[js-acc-item]');
    const removestyle = this.closest('[js-acc-single-content]');

    console.log('removestyle', removestyle, removeclass);

    let addtext = null;
    if (removeclass) {
      addtext = removeclass.querySelector('.faq-category-selected');
      console.log(addtext, 'addtext');
    }

    if (removeclass) {
      removeclass.classList.remove('active');
    }

    if (removestyle) {
      removestyle.style.removeProperty('max-height');
    }

    if (addtext) {
      addtext.textContent = this.textContent.trim();
    }

      

      // remove active classes
      tabTitles.forEach(t => t.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));

      // add active class
      this.classList.add('active');

      const matchedContent = document.querySelector(
        `.product-tab-content[data-content="${target}"]`
      );

      if (matchedContent) {
        matchedContent.classList.add('active');
      }
    });
  });
});



// scroll stop after Contact Form submition 

 (function() {
setTimeout(() => {
  if (window.location.hash === '#ContactForm') {
    const contactSection = document.querySelector('.landing_page_contact_form');
    const stickyHeader  = document.querySelector('header');   // ← replace with your header selector

    if (contactSection) {
      const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;

      /* absolute position of the section in the document */
      const sectionTop = contactSection.getBoundingClientRect().top + window.pageYOffset;
      /* scroll so the section sits just below the sticky header */
      window.scrollTo({
        top: sectionTop - headerHeight,
        behavior: 'smooth'
      });
    }
  }
}, 700);  
})();
//end 






document.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelectorAll('.section-testimonials .swiper-slide');
  const showBtn = document.getElementById('showMoreSlides');

  // first 3 show, rest hide
  slides.forEach((slide, index) => {
    if (index >= 6) {
      slide.classList.add('hidden-slide');
    }
  });

  // button click par show
  showBtn.addEventListener('click', () => {
    slides.forEach((slide) => {
      slide.classList.remove('hidden-slide');
    });

    showBtn.style.display = 'none'; // optional: button hide
  });
});